import ITimestamps from "@/models/TimestampsInterface";

export default class NoteVersion implements ITimestamps {
  public id: number;
  public content = "";
  public created_at: string | null = null;
  public updated_at: string | null = null;
}
